import { render, staticRenderFns } from "./CreateBuilding.vue?vue&type=template&id=1168a03e"
import script from "./CreateBuilding.vue?vue&type=script&lang=js"
export * from "./CreateBuilding.vue?vue&type=script&lang=js"
import style0 from "./CreateBuilding.vue?vue&type=style&index=0&id=1168a03e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports